export interface Template {
    id: number;
    title: string;
    author: string;
    type: TemplateType;
    content: string;
    createdAt: Date;
    draftState: DraftState;
    framedContent: string;
}

export enum TemplateType {
    DelA = 1,
    DelB = 2
}

export enum DraftState {
    Draft = 1,
    Published = 2,
    Historic = 3
}
